export default {
    defaultOutputParams:{
        dynamic:{
            cron:'1 hour',
            restartDependencies:false
        },
        record:{
            cron:'cron("* * * * *")'
        },
        identity:{},
        static:{}
    },
    allTypes:['dynamic', 'record', 'static','identity']
}